import { Component } from 'react';

import { getCountry } from '@iwIntlProvider/CountryProvider';
import { logError, TAGS } from '@iwLogger/IwDataDogLogger';
import { FormattedMessage } from 'react-intl';

import styles from './FallbackErrorModal.module.css';
import { reloadCurrentLocation } from '../../../iwRouter/LocationHelper';
import { WarningTriangleSVG } from '../../../svgComponents/warningTriangleSVG';
import { TrackErrorModalOpened } from '../../../tracking/amplitude.helpers';

class FallbackErrorModal extends Component {
    componentDidMount() {
        TrackErrorModalOpened();

        if (getCountry() === 'DE') {
            logError(`Fallback error UI shown`, {
                tags: TAGS.DE_LENDING
            });
        }
    }

    render() {
        return (
            <div
                data-testid="fallback-error-modal"
                className={styles.FallbackErrorModal}
            >
                <WarningTriangleSVG className={styles.icon} />
                <div className={styles.label}>
                    <FormattedMessage
                        id="_.modal.fallback_error.label"
                        defaultMessage="Oops, it looks like something went wrong"
                    />
                </div>
                <button
                    className={styles.button}
                    onClick={() => reloadCurrentLocation()}
                >
                    <FormattedMessage
                        id="_.modal.fallback_error.refresh"
                        defaultMessage="Refresh"
                    />
                </button>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default FallbackErrorModal;
